<div class="payment-wrapper">
  <div class="payment-card">
    <form [formGroup]="paymentForm">

      <div class="payment-header text-center">
        <div class="header-icon">
          <i class="bi bi-credit-card-2-front-fill"></i>
        </div>
        <h3>{{ "Payment" | translate }}</h3>
      </div>

      <div class="product-summary" *ngIf="product">
        <div class="product-summary-inner">
          <div class="product-info">
            <i class="bi bi-box-seam-fill product-icon"></i>
            <span class="product-desc">{{ product.description }}</span>
          </div>
          <div class="product-price">
            <span>{{ product.amount / 100 }}</span>
            <small>{{ "L.E" | translate }}</small>
          </div>
        </div>
      </div>

      <div class="row g-3 mt-2">

        <div class="col-12 col-sm-6">
          <label>{{ "First Name" | translate }} *</label>
          <div class="input-container" [class.input-error]="firstNameError" [class.input-readonly]="!isNewUser">
            <i class="bi bi-person left-icon"></i>
            <input
              type="text"
              placeholder="{{ 'Enter your first name' | translate }}"
              formControlName="firstName"
              [attr.disabled]="!isNewUser ? true : null"
            />
          </div>
          <small class="error-msg" *ngIf="firstNameError">{{ firstNameError }}</small>
        </div>

        <div class="col-12 col-sm-6">
          <label>{{ "Last Name" | translate }} *</label>
          <div class="input-container" [class.input-error]="lastNameError" [class.input-readonly]="!isNewUser">
            <i class="bi bi-person left-icon"></i>
            <input
              type="text"
              placeholder="{{ 'Enter your last name' | translate }}"
              formControlName="lastName"
              [attr.disabled]="!isNewUser ? true : null"
            />
          </div>
          <small class="error-msg" *ngIf="lastNameError">{{ lastNameError }}</small>
        </div>

        <div class="col-12 col-sm-6">
          <label>{{ "Phone Number" | translate }} *</label>
          <div
            class="input-container"
            [class.input-error]="phoneError"
            [class.input-readonly]="!isNewUser && !isGoogleUserMissingPhone"
          >
            <i class="bi bi-telephone left-icon"></i>
            <input
              type="text"
              placeholder="{{ 'Enter your phone number' | translate }}"
              formControlName="phone"
              [attr.disabled]="(!isNewUser && !isGoogleUserMissingPhone) ? true : null"
              (keypress)="onlyNumbers($event)"
            />
          </div>
          <small class="google-phone-hint" *ngIf="isGoogleUserMissingPhone">
            <i class="bi bi-google me-1"></i>
            أدخل رقم هاتفك لإتمام الدفع
          </small>
          <small class="error-msg" *ngIf="phoneError">{{ phoneError }}</small>
        </div>

        <!-- ✅ الإيميل اختياري للجميع -->
        <div class="col-12 col-sm-6">
          <label>
            {{ "Email" | translate }}
            <span class="text-muted fw-normal" style="font-size: 0.85em;">(اختياري)</span>
          </label>
          <div
            class="input-container"
            [class.input-error]="emailError"
            [class.input-readonly]="!isNewUser && !!paymentForm.get('email')?.disabled"
          >
            <i class="bi bi-envelope left-icon"></i>
            <input
              type="email"
              placeholder="{{ 'أدخل بريدك الإلكتروني (اختياري)' | translate }}"
              formControlName="email"
            />
          </div>
          <small class="error-msg" *ngIf="emailError">{{ emailError }}</small>
        </div>

        <div class="col-12" *ngIf="isNewUser">
          <label>كلمة المرور *</label>
          <div class="input-container" [class.input-error]="passwordError">
            <i class="bi bi-lock left-icon"></i>
            <input
              type="password"
              placeholder="أنشئ كلمة مرور (8 أحرف على الأقل)"
              formControlName="password"
            />
          </div>
          <small class="error-msg" *ngIf="passwordError">{{ passwordError }}</small>
        </div>

      </div>

      <div class="alert-error mt-3" *ngIf="errorMessage">
        <i class="bi bi-exclamation-triangle-fill me-1"></i>
        {{ errorMessage }}
      </div>

      <div class="text-center mt-4">
        <button
          type="submit"
          class="pay-btn"
          (click)="onSubmit()"
          [disabled]="paymentForm.invalid || isLoading"
          [class.btn-disabled]="paymentForm.invalid || isLoading"
        >
          <span *ngIf="!isLoading">
            {{ isNewUser ? 'إنشاء حساب والدفع' : ("Submit" | translate) }}
          </span>
          <span *ngIf="isLoading">
            <i class="bi bi-hourglass-split me-1"></i> جاري المعالجة...
          </span>
        </button>
      </div>

      <p class="new-user-note text-center mt-3" *ngIf="isNewUser">
        <i class="bi bi-info-circle me-1"></i>
        سيتم إنشاء حسابك تلقائياً حتى تتمكن من الوصول إلى الكورسات في أي وقت
      </p>

      <p class="secure-note text-center mt-3">
        <i class="bi bi-shield-check me-1"></i>
        {{ "Your payment is secured and encrypted" | translate }}
      </p>

    </form>
  </div>
</div>

<div class="modal-overlay" *ngIf="showEmailExistsModal" (click)="closeModal()">
  <div class="modal-box" (click)="$event.stopPropagation()">

    <div class="modal-icon">
      <i class="bi bi-telephone-x-fill"></i>
    </div>

    <h4>رقم الهاتف مستخدم بالفعل</h4>
    <p>
      رقم الهاتف
      <strong>{{ paymentForm.getRawValue().phone }}</strong>
      مسجّل من قبل. سجّل دخولك للمتابعة أو استخدم رقم هاتف آخر
    </p>

    <div class="modal-actions">
      <button class="btn-login" (click)="goToLogin()">
        <i class="bi bi-box-arrow-in-right me-1"></i>
        تسجيل الدخول
      </button>
    </div>

    <button class="modal-close" (click)="closeModal()">
      <i class="bi bi-x-lg"></i>
    </button>

  </div>
</div>